import ApiService from '../api.service'
import { TokenService } from '@/services/storage.service'

const ItemProdDbService = {

    //----------------Prod Db Item ------------
    searchProdDbItems: async (payload) => {
        const url = `/api/ItemProdDb/searchProdDbItems`

        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },
    //----------------Mapping GP Item into Prod Db Item ------------
    getNotMappedGpItems: async (payload) => {
        const url = `/api/ItemProdDb/getNotMappedGpItems`

        const requestData = {
            method: 'post',
            url: url,
            data: {},
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },

    mapGpItemToItmProdDbItem: async (payload) => {
        const url = `/api/ItemProdDb/mapGpItemToItmProdDbItem`

        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }    

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }    

    },    

    //----------------Prod Db Item ProdDbType------------
    saveItemProdType: async (payload) => {
        const url = `/api/ItemProdDb/saveItemProdType`

        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },

    //----------------Prod Db Item Status------------
    saveItemStatus: async (payload) => {
        const url = `/api/ItemProdDb/saveItemStatus`

        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },

    //----------------Prod Db Item X Doc------------
    saveItemXDoc: async (payload) => {
        const url = `/api/ItemProdDb/saveItemXDoc`

        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }    

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }    

    },    

    deleteItemXDoc: async (payload) => {
        const url = `/api/ItemProdDb/deleteItemXDoc?id=${payload}`

        const requestData = {
            method: 'post',
            url: url,
            data: {},
        }    

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }    

    },    

    //----------------Prod Item Doc-------------
    getItmDocs: async (payload) => {
        const url = `/api/ItemProdDb/getItmDocs?docCategoryId=${payload}`

        const requestData = {
            method: 'post',
            url: url,
            data: {},
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },

    saveItmDoc: async (payload) => {
        const url = `/api/ItemProdDb/saveItmDoc`

        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }    

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }    

    },    
}

export default ItemProdDbService